<template>
  <div class="newAddress-section">
    <div class="newAddress-header">
      <p>编辑地址</p>
      <el-button class="return-button" @click="() => this.$router.back()"
        >返回</el-button
      >
    </div>
    <div class="newAddress-main">
      <div class="address-info">
        <el-form
          style="font-size: 12px;"
          :model="editForm"
          size="small"
          ref="editForm"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item
            class="form-item"
            prop="district_codes"
            label="地址信息"
          >
            <el-cascader
              class="form-input"
              :options="districtOption"
              :props="{ value: 'value', label: 'label' }"
              v-model="editForm.district_codes"
            ></el-cascader>
          </el-form-item>
          <el-form-item class="form-item" prop="name" label="收货人姓名">
            <el-input
              v-model="editForm.name"
              placeholder="请输入姓名"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item class="form-item" prop="phone" label="收货人电话">
            <el-input
              v-model="editForm.phone"
              placeholder="请输入电话"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item class="form-item" prop="address" label="详细地址">
            <el-input
              resize="none"
              type="textarea"
              placeholder="请输入内容"
              v-model="editForm.address"
              rows="6"
            ></el-input>
          </el-form-item>
          <div class="default_check">
            是否为默认地址
            <el-checkbox v-model="editForm.is_default"></el-checkbox>
          </div>
        </el-form>
      </div>
      <div class="button-content">
        <el-button class="return-button" @click="() => this.$router.back()"
          >返回</el-button
        >
        <el-button class="save-button" @click="handleSubmit">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import constService from "@/global/service/const";
import giftService from "@/global/service/gift";
export default {
  data() {
    return {
      rules: {
        address: [
          { required: true, message: "请输入详情地址", trigger: "blur" }
        ],
        name: [
          { required: true, message: "请填写收件人名称", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "目前只支持中国大陆的手机号码",
            trigger: "blur"
          }
        ],
        district_codes: [
          { required: true, message: "请填写地址信息", trigger: "blur" }
        ]
      },
      editForm: {
        district_codes: [],
        name: "",
        phone: "",
        address: "",
        is_default: false
      },
      districtOption: []
    };
  },
  created() {
    this.getData();
    this.getDistrict();
  },
  methods: {
    getData() {
      let id = this.$route.params.id;
      giftService.addressDetail(id).then(res => {
        this.editForm = res;
      });
    },
    getDistrict() {
      constService.districts().then(res => {
        this.districtOption = res;
      });
    },
    handleSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          let id = this.$route.params.id;
          const params = {
            name: this.editForm.name,
            phone: this.editForm.phone,
            district_codes: this.editForm.district_codes,
            address: this.editForm.address,
            is_default: this.editForm.is_default
          };
          giftService.addressEdit(id, params).then(() => {
            this.$message.success("修改成功");
            this.$router.push({
              name: "my_site"
            });
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.newAddress-section {
  font-size: 12px;
  color: #2c3e50;
  .newAddress-header {
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    padding: 0 10px;
    align-items: center;
    height: 40px;
    .return-button {
      padding: 0;
      font-size: 12px;
      color: #f0b32f;
      border: 1px solid #f0b32f;
      width: 56px;
      height: 32px;
    }
  }
  .newAddress-main {
    margin-top: 10px;
    padding: 20px 40px 20px 20px;
    background: #ffffff;
    .default_check {
      text-align: left;
      margin-left: 100px;
    }
    .button-content {
      margin-top: 10px;
      text-align: left;
      margin-left: 100px;
      .return-button {
        font-size: 12px;
        width: 56px;
        height: 32px;
        padding: 0;
        color: #f0b32f;
        border: 1px solid #f0b32f;
      }
      .save-button {
        font-size: 12px;
        width: 56px;
        height: 32px;
        padding: 0;
        color: #ffffff;
        background: #f0b32f;
      }
    }
  }
}
/deep/.el-form-item__content {
  text-align: left;
}
/deep/.el-form-item__content .el-form-item__error {
  left: 70px;
}
.form-input {
  width: 270px;
}
</style>
